import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useSlotsTrackerApi } from '@pages/demos'
import { useCommonStore } from '@shared/model'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const commonStore = useCommonStore()

  void useSlotsTrackerApi({
    route: to,
    onStart: () => {
      commonStore.setLoading(true)
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
